export default __webpack_public_path__ + "static/media/Unscharfe_Zeitung.679b5be2.jpg";